import methods from './methods';
import computed from './computed';
import filters from './filters';
import directives from './directives';

import store from '../lib/store';
import util from '../lib/util';
import win from '../lib/win';
import json from '../lib/json';
import storage from '../lib/storage';
import loader from '../lib/loader';
import url from '../lib/url';
import http from '../lib/http';
import cookie from '../lib/cookie';
import html from '../lib/html';
import time from '../lib/time';
import events from '../lib/events';

export default {
	data() {
		return { store, util, win, json, storage, loader, url, http, cookie, html, time, events };
	},
	methods,
	computed,
	filters,
	directives
};